import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const REASONS = ["Spam", "Abusive content", "Inappropriate content", "Misleading content", "Other"];

export default function ReportDialog({ open, onClose, type, id }) {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const submit = async () => {
    if (!reason) return toast.error("Please choose a reason");
    try {
      await api.post("/reports", { target_type: type, target_id: id, reason, details });
      toast.success("Thank you. Our moderators will review this.");
      onClose(); setReason(""); setDetails("");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="report-dialog" className="max-w-sm rounded-3xl bg-[#FFFDF7]">
        <DialogTitle className="font-display text-xl text-[#6B1D2F]">Report {type}</DialogTitle>
        <DialogDescription>Help keep Bhakti Sakhi a safe, respectful space.</DialogDescription>
        <div className="space-y-2">
          {REASONS.map((r) => (
            <button key={r} onClick={() => setReason(r)} data-testid={`report-reason-${r.split(" ")[0].toLowerCase()}`}
              className={`w-full rounded-xl border px-4 py-2.5 text-left text-sm ${reason === r ? "border-[#6B1D2F] bg-[#FDF2F4] font-semibold" : "border-[#E7E0D3] bg-white"}`}>{r}</button>
          ))}
          <textarea className="input" placeholder="Details (optional)" value={details} onChange={(e) => setDetails(e.target.value)} data-testid="report-details" />
          <button onClick={submit} className="btn-maroon w-full" data-testid="report-submit">Submit report</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
